import SectionHeading from "@/components/base/SectionHeading";
import WorkCard from "@/components/feature/WorkCard";
import { worksList } from "@/mocks/works";

export default function WorksShowcase() {
  const picks = [...worksList].sort((a, b) => b.favoriteCount - a.favoriteCount).slice(0, 5);

  return (
    <section aria-labelledby="home-works-heading" className="w-full bg-background-100 border-y border-background-200">
      <div className="w-full px-4 md:px-6 lg:px-10 py-10 md:py-14">
        <SectionHeading
          kicker="WORKS"
          title="热门作品推荐"
          description="从原创机甲到治愈日常，编辑部根据口碑与讨论度挑选的本季必看。"
          actionLabel="进入作品库"
          actionTo="/works"
        />
        <h2 id="home-works-heading" className="sr-only">热门作品推荐</h2>
        {picks.length === 0 ? (
          <p className="text-sm text-foreground-500">暂无相关内容</p>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
            {picks.map((item) => (
              <WorkCard key={item.id} item={item} />
            ))}
          </div>
        )}
      </div>
    </section>
  );
}